import { render, staticRenderFns } from "./ElementRtmp.vue?vue&type=template&id=51711a42&"
import script from "./ElementRtmp.vue?vue&type=script&lang=js&"
export * from "./ElementRtmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports